import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { _clientReportFeedbackCollection } from "@/services/clientHelp";
import { handleAPICatch, showSuccessToast } from "@/utilities/utils";

const initialState = {
  showHelpYoutubeModal: false,
  showUpdateLoginAnnuouncementModal: false,
  ytPlayList: [],
  showReportFeedbackModal: false,
};

export const clientReportFeedbackCollection = createAsyncThunk(
  "clientUsers/clientReportFeedbackCollection",
  async (data, { dispatch, getState }) => {
    const { postData, setSubmitting } = data;
    setSubmitting(true);
    try {
      let response = await _clientReportFeedbackCollection(postData);
      const { message } = response;
      showSuccessToast(message);
      dispatch(toggleShowReportFeedbackModal(false));
    } catch (error) {
      handleAPICatch(error);
    } finally {
      setSubmitting(false);
    }
  },
);

const clientHelpSlice = createSlice({
  name: "clientHelp",
  initialState,
  reducers: {
    toggleShowHelpYoutubeModal: (state, action) => {
      state.showHelpYoutubeModal = action.payload;
    },
    toggleShowReportFeedbackModal: (state, action) => {
      state.showReportFeedbackModal = action.payload;
    },
    updateYtPlayList: (state, action) => {
      state.ytPlayList = action.payload;
    },
  },
});

export const {
  toggleShowHelpYoutubeModal,
  toggleShowReportFeedbackModal,
  updateYtPlayList,
} = clientHelpSlice.actions;

export default clientHelpSlice.reducer;
